import React from 'react';

export const InBrowser = ({ children }: { children: React.ReactNode }) => (__IS_SERVER__ ? null : <>{children}</>);
export const AtServer = ({ children }: { children: React.ReactNode }) => (__IS_SERVER__ ? <>{children}</> : null);
